import { useMutation } from '@tanstack/react-query';
import { httpClient, type HttpClientConfig } from '@/shared/api/httpClient';

/**
 * Delete a device-uploaded media file.
 *   DELETE v1/common/deleteFile?mediaId=...
 * Do not call for gallery-selected creatives.
 */
export function useDeleteFile() {
  return useMutation({
    mutationFn: async ({ mediaId }: { mediaId: string }) => {
      const { data } = await httpClient.delete(
        `v1/common/deleteFile?mediaId=${mediaId}`,
        {
          // Signup/onboarding may have SESSION_ID only — avoid 401 → login.
          skipAuthLogout: true,
        } as HttpClientConfig,
      );
      return data;
    },
  });
}
